import React from 'react';
import { Helmet } from "react-helmet";
import Layout from '../components/Layout';
import AudiForm from '../components/AudiForm';
import Disclaimer from '../components/Disclaimer';
import ReturnToButton from '../components/ReturnToButton';
import queryString from 'query-string';
import { formatMobile } from '../functions/textFormatting';
import { gtmPageview } from '../functions/gtm';
import {
    PATH_EV_RYI,
    PATH_THANKS,
    FIELD_TEXT,
    FIELD_CHECKBOX,
    LABEL_OPTIN,
    UI_AUDI
} from '../constants';

const fields = [
    [
        {
            field: FIELD_TEXT,
            name: "firstName",
            label: "First name",
            colClass: "col-12 col-tiny"
        },
        {
            field: FIELD_TEXT,
            name: "lastName",
            label: "Last name",
            colClass: "col-12 col-tiny"
        }
    ],
    {
        field: FIELD_TEXT,
        name: "emailAddress",
        label: "Email"
    },
    {
        field: FIELD_TEXT,
        name: "mobilePhone",
        label: "Mobile phone",
        formatValue: formatMobile,
        colClass: "col-12 col-small-6"
    },
    {
        field: FIELD_TEXT,
        name: "postCode",
        label: "Postcode",
        colClass: "col-12 col-small-6"
    },
    {
        field: FIELD_CHECKBOX,
        name: "optIn",
        label: LABEL_OPTIN
    }
];

class EVRegisterInterest extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            submitted: false,
            submittedData: {}
        }
    }

    componentDidMount() {
        gtmPageview(PATH_EV_RYI);
    }

    onSubmit = (values) => {
        this.setState({submitted: true, submittedData: values});
        this.props.history.push(`${PATH_EV_RYI}${PATH_THANKS}`);
        gtmPageview(`${PATH_EV_RYI}${PATH_THANKS}`);
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const {submitted, submittedData} = this.state;

        return (
            <Layout ui={query.ui || UI_AUDI} theme={query.theme} embedded={query.embedded} wide={query.wide}>
                <Helmet>
                    <title>Keep me updated on Audi Australia</title>
                </Helmet>

                <main className="audi-forms__page">

                    {submitted && <div className="py-3 py-medium-5" style={{maxWidth: "840px"}}>
                        <h1 className="aui-headline-4 mb-4">Thanks for your interest.</h1>
                        <p className="mb-3">We’ll be sure to send you updates.</p>
                        <ReturnToButton query={query} theme={query.theme} />
                    </div>}

                    {!submitted && <div className="pt-3 pt-medium-5" style={{maxWidth: "840px"}}>
                        <h1 className="aui-headline-4 mb-4">Keep me updated on Audi Australia</h1>
                        <p className="mb-5">Stay on top of what’s happening in the world of Audi. Be the first to hear about Audi news, upcoming models, special offers and exclusive event invitations.</p>
                        <AudiForm formName="EVRYI"
                            fields={fields}
                            schema={{optIn: {presence: {message: "This field is required", allowEmpty: false}}}}
                            onSubmitSuccess={this.onSubmit}
                            style={{maxWidth: "840px"}}
                            theme={query.theme}
                        />
                        <Disclaimer theme={query.theme} />
                    </div>}

                </main>
            </Layout>
        );
    }

}

export default EVRegisterInterest;
